import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3V19H15.2861L11.9951 21.7266L8.74316 19H3V3H21ZM10.5986 9.59961L7.99902 10.5996V11.4004L10.5986 12.4004L11.5986 15H12.3984L13.3984 12.4004L15.999 11.4004V10.5996L13.3984 9.59961L12.3984 7H11.5986L10.5986 9.59961Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleSparkle;
